module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[8]495.bd67d19.woff2";